<template>
  <w-dialog :show="show"
            show-close
            box-style="width: 587px;"
            title="修改清单"
            :wallStyle="{zIndex: 1009}"
            footer-style="padding-bottom: 24px;border-top: 0;"
            @close="cancelHandle">
    <div class="dialog-body--database__edit">
      <table class="ui-table revise-table" width="100%" cellspacing="0" cellpadding="0">
        <tbody>
        <tr>
          <td class="font-center ui-w60">名称</td>
          <td>
            <w-input
              type="textarea"
              rows="3"
              v-model="formData.description"
            ></w-input>
            <!--<textarea class="ui-textarea dialog-width name-height"-->
                      <!--v-model="formData.description">-->
            <!--</textarea>-->
          </td>
        </tr>
        <tr>
          <td class="font-center ui-w60">项目特征</td>
          <td>
            <w-input
              type="textarea"
              rows="3"
              v-model="formData.spec"
            ></w-input>
            <!--<textarea class="ui-textarea dialog-width spec-height" v-model="formData.spec"></textarea>-->
          </td>
        </tr>
        <tr>
          <td class="font-center ui-w60">单位</td>
          <td>
            <div class="text-select dialog-width">
              <w-select size="small" v-model="formData.unit">
                <w-option value="组">组</w-option>
                <w-option value="宗">宗</w-option>
                <w-option value="元">元</w-option>
                <w-option value="套">套</w-option>
                <w-option value="台">台</w-option>
                <w-option value="千米">千米</w-option>
                <w-option value="辆">辆</w-option>
                <w-option value="块">块</w-option>
                <w-option value="公斤">公斤</w-option>
                <w-option value="付">付</w-option>
                <w-option value="处">处</w-option>
                <w-option value="部">部</w-option>
                <w-option value="千克">千克</w-option>
                <w-option value="kg">kg</w-option>
                <w-option value="吨">吨</w-option>
                <w-option value="t">t</w-option>
                <w-option value="立方米">立方米</w-option>
                <w-option value="m3">m3</w-option>
                <w-option value="米">米</w-option>
                <w-option value="m">m</w-option>
                <w-option value="平方米">平方米</w-option>
                <w-option value="m2">m2</w-option>
                <w-option value="工日">工日</w-option>
                <w-option value="个">个</w-option>
                <w-option value="台班">台班</w-option>
                <w-option value="座">座</w-option>
                <w-option value="km">km</w-option>
                <w-option value="樘">樘</w-option>
                <w-option value="件">件</w-option>
                <w-option value="根">根</w-option>
                <w-option value="系统">系统</w-option>
                <w-option value="株">株</w-option>
                <w-option value="丛">丛</w-option>
                <w-option value="缸">缸</w-option>
                <w-option value="只">只</w-option>
                <w-option value="支">支</w-option>
                <w-option value="对">对</w-option>
                <w-option value="份">份</w-option>
                <w-option value="攒">攒</w-option>
                <w-option value="榀">榀</w-option>
              </w-select>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <template slot="footer">
      <w-button type="primary" @click="submitHandle">确认</w-button>
      <w-button type="minor" @click="cancelHandle">取消</w-button>
    </template>
  </w-dialog>
</template>
<script>
import databaseEditMixin from '@/assets/mixins/database-edit'
export default {
  name: 'DialogEditInventory',
  mixins: [databaseEditMixin],
  data () {
    return {
      pageType: 'inventory'
    }
  }
}
</script>
<style lang="less" type="text/less">
</style>
